var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.421,
    height: 20.963,
    viewBox: "0 0 17.421 20.963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673",
    "data-name": "Rectangle 1673",
    width: 17.421,
    height: 20.963,
    transform: "translate(0 0)",
    fill: "#1f6de7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10858",
    "data-name": "Group 10858",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10326",
    "data-name": "Group 10326",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17883",
    "data-name": "Path 17883",
    d: "M6.638,3.982a13.582,13.582,0,0,0,1.578,3.5c1.219,1.62,2.894,2.245,4.76,2.854a.192.192,0,0,1,0,.288A12.778,12.778,0,0,0,9.5,12.189c-1.777,1.351-2,2.642-2.776,4.569-.062.152-.1.328-.317.2-.093-.055-.655-1.76-.772-2.034A6.637,6.637,0,0,0,2.026,11.33C1.381,11.057.68,10.887.044,10.6L0,10.456.129,10.3a8.67,8.67,0,0,0,4.6-2.7A12.3,12.3,0,0,0,6.368,4.048c.053-.093.176-.091.27-.066",
    fill: "#1f6de7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17884",
    "data-name": "Path 17884",
    d: "M14.174,0a4.094,4.094,0,0,0,1.89,2.719c.4.215.841.3,1.247.486.163.074.135.136-.019.211-.247.119-.606.189-.868.3a3.427,3.427,0,0,0-1.895,1.895c-.079.182-.258.847-.329.934a.118.118,0,0,1-.139.048c-.062-.013-.375-1.026-.452-1.187a3.636,3.636,0,0,0-1.584-1.6C11.76,3.683,11,3.5,10.838,3.369a.1.1,0,0,1-.03-.12c.017-.052.885-.313,1.029-.375A3.893,3.893,0,0,0,14.041,0Z",
    fill: "#1f6de7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17885",
    "data-name": "Path 17885",
    d: "M14.172,14.366a3.963,3.963,0,0,0,2.252,2.871c.183.078.837.25.934.329a.12.12,0,0,1,.048.139c-.015.069-1.11.409-1.311.514a4.054,4.054,0,0,0-1.913,2.71c-.008.044-.094.037-.122.028-.072-.023-.433-1.174-.56-1.405a4.018,4.018,0,0,0-2.663-1.819c-.044-.008-.038-.094-.029-.121.02-.064,1.074-.4,1.249-.483a4.061,4.061,0,0,0,1.983-2.766Z",
    fill: "#1f6de7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiicon);
export default __webpack_public_path__ + "static/media/aiicon.50cc46464fb94c861fac7e5f03d7b940.svg";
export { ForwardRef as ReactComponent };